export const COLUMNS = {
  REGISTRATION_NAME: 'Registration Name',
  PROGRAM_NAME: 'Program Name',
  TYPE_OF_DEAL: 'Type of Deal',
  LINKED_CUSTOMER_ACCOUNT: 'Linked Customer Account',
  ATLASSIAN_SALES_REP: 'Atlassian Sales Rep',
  ATLASSIAN_SSE_REP: 'Atlassian SSE Rep',
  REGISTRATION_STATUS: 'Registration - Status',
  REGISTRATION_DEAL_ID: 'Registration - Deal ID',
  GSAC_TICKET: 'GSAC Ticket',
  REGISTRATION_APPROVAL_ID: 'Registration - Approval ID',
  REGISTRATION_SUBMITTED_DATE: 'Registration Submitted Date',
  REGISTRATION_EXPIRATION_DATE: 'Registration Expiration Date',
  DENIAL_REASON: 'Denial Reason',
  COMMENTS: 'Comments',
  SOW_AND_PO_AMOUNT: 'Statement of Work Amount/Purchase Order Amount',
  EXTENSION_STATUS: 'Extension Status',
  QUOTE_ID: 'Quote ID',
  ACTION: 'Action',
};

export const HEADERS = [
  {
    name: COLUMNS.REGISTRATION_NAME,
    content: COLUMNS.REGISTRATION_NAME,
    customClassNames: 'col-registration-name',
  },
  {
    name: COLUMNS.PROGRAM_NAME,
    content: COLUMNS.PROGRAM_NAME,
    customClassNames: 'col-program-name',
  },
  {
    name: COLUMNS.TYPE_OF_DEAL,
    content: COLUMNS.TYPE_OF_DEAL,
    customClassNames: 'col-type-of-deal',
  },
  {
    name: COLUMNS.LINKED_CUSTOMER_ACCOUNT,
    content: COLUMNS.LINKED_CUSTOMER_ACCOUNT,
    customClassNames: 'col-linked-customer-account',
  },
  {
    name: COLUMNS.ATLASSIAN_SALES_REP,
    content: COLUMNS.ATLASSIAN_SALES_REP,
    customClassNames: 'col-atlassian-sales-rep',
  },
  {
    name: COLUMNS.ATLASSIAN_SSE_REP,
    content: COLUMNS.ATLASSIAN_SSE_REP,
    customClassNames: 'col-atlassian-sse-rep',
  },
  {
    name: COLUMNS.REGISTRATION_STATUS,
    content: COLUMNS.REGISTRATION_STATUS,
    customClassNames: 'col-registration-status',
  },
  {
    name: COLUMNS.REGISTRATION_DEAL_ID,
    content: COLUMNS.REGISTRATION_DEAL_ID,
    customClassNames: 'col-registration-deal-id',
  },
  {
    name: COLUMNS.GSAC_TICKET,
    content: COLUMNS.GSAC_TICKET,
    customClassNames: 'col-gsac-ticket',
  },
  {
    name: COLUMNS.REGISTRATION_APPROVAL_ID,
    content: COLUMNS.REGISTRATION_APPROVAL_ID,
    customClassNames: 'col-registration-approval-id',
  },
  {
    name: COLUMNS.REGISTRATION_SUBMITTED_DATE,
    content: COLUMNS.REGISTRATION_SUBMITTED_DATE,
    customClassNames: 'col-registration-submitted-date',
  },
  {
    name: COLUMNS.REGISTRATION_EXPIRATION_DATE,
    content: COLUMNS.REGISTRATION_EXPIRATION_DATE,
    customClassNames: 'col-registration-expiration-date',
  },
  {
    name: COLUMNS.DENIAL_REASON,
    content: COLUMNS.DENIAL_REASON,
    customClassNames: 'col-denial-reason',
  },
  {
    name: COLUMNS.COMMENTS,
    content: COLUMNS.COMMENTS,
    customClassNames: 'col-comments',
  },
  {
    name: COLUMNS.SOW_AND_PO_AMOUNT,
    content: COLUMNS.SOW_AND_PO_AMOUNT,
    customClassNames: 'col-sow-and-po-amount',
  },
  {
    name: COLUMNS.EXTENSION_STATUS,
    content: COLUMNS.EXTENSION_STATUS,
    customClassNames: 'col-extension-status',
  },
  {
    name: COLUMNS.QUOTE_ID,
    content: COLUMNS.QUOTE_ID,
    customClassNames: 'col-quote-id',
  },
  {
    name: COLUMNS.ACTION,
    content: COLUMNS.ACTION,
    customClassNames: 'col-action',
  },
];
